var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { custom, disgardOldValue, object, withDefault } from '../../../utils/serializr/serializr';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { WordTask } from '../WordTask/WordTask';
import { legacy } from '../../../utils/serializr/schema/outer/legacy';
import { editable } from '../../../utils/mobx/decorators/editable';
import { KnowAWordLegacy } from './KnowAWordLegacy';
export class KnowAWordStore {
    parent;
    wordTask;
    constructor({ parent }) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get knowAWordLegacy() {
        return new KnowAWordLegacy(this);
    }
    get questionTypeLegacy() {
        return this.knowAWordLegacy;
    }
    get form() {
        return 0; // detect form automatically based on word
    }
    set form(l) { }
    get word() {
        return this.wordTask.wordString;
    }
    set word(s) {
        this.wordTask.wordString = s;
    }
    get prefix() {
        if (!this.wordTask.ownAspect.prefix.local.has.text)
            return '';
        return this.wordTask.ownAspect.prefix.aspectContent.local.primaryTextBasis;
    }
    set prefix(p) {
        if (p.length === 0)
            return;
        this.wordTask.ownAspect.prefix.aspectContent.local.primaryTextBasis = p;
    }
    get postfix() {
        if (!this.wordTask.ownAspect.postfix.local.has.text)
            return '';
        return this.wordTask.ownAspect.postfix.aspectContent.local.primaryTextBasis;
    }
    set postfix(p) {
        if (p.length === 0)
            return;
        this.wordTask.ownAspect.postfix.aspectContent.local.primaryTextBasis = p;
    }
    get accuracy() {
        return this.wordTask.requiredAccuracy;
    }
    set accuracy(n) {
        this.wordTask.requiredAccuracy = n;
    }
    get contains() {
        return this.wordTask.isSufficientToContainWord ? 1 : 0;
    }
    set contains(b) {
        this.wordTask.isSufficientToContainWord = !!b;
    }
    get solution() {
        return this.wordTask.solutionString;
    }
    set solution(s) {
        this.wordTask.solutionString = s;
    }
    get manualSend() {
        // obsolete
        return this.wordTask.doesAlwaysRequireManualSend ? 1 : 0;
    }
    set manualSend(b) {
        // obsolete
        this.wordTask.doesAlwaysRequireManualSend = !!b;
    }
    get casesensitive() {
        return this.wordTask.isCaseSensitive ? 1 : 0;
    }
    set casesensitive(b) {
        this.wordTask.isCaseSensitive = !!b;
    }
    get showAlternatives() {
        return this.wordTask.shouldShowAlternativesOnReveal ? 1 : 0;
    }
    set showAlternatives(b) {
        this.wordTask.shouldShowAlternativesOnReveal = !!b;
    }
    get regex() {
        return this.wordTask.isRegex ? 1 : 0;
    }
    set regex(b) {
        this.wordTask.isRegex = !!b;
    }
    get legacyImages() {
        return undefined;
        return this.knowAWordLegacy.legacyImages;
    }
    set legacyImages(l) {
        if (!l)
            return;
        this.knowAWordLegacy.legacyImages = l;
    }
    get legacyComments() {
        return undefined;
        return this.knowAWordLegacy.legacyComments;
    }
    set legacyComments(l) {
        if (!l)
            return;
        this.knowAWordLegacy.legacyComments = l;
    }
    static get serializeInfo() {
        return {
            props: {
                wordTask: withDefault(object(WordTask, { parentDepth: 2 }), {}),
                form: true,
                word: true,
                regex: true,
                prefix: true,
                postfix: true,
                accuracy: true,
                contains: true,
                solution: true,
                manualSend: true,
                casesensitive: true,
                showAlternatives: true,
                legacyImages: legacy(disgardOldValue(custom(a => a, a => a))),
                legacyComments: legacy(disgardOldValue(custom(a => a, a => a))),
            },
        };
    }
}
__decorate([
    editable()
], KnowAWordStore.prototype, "parent", void 0);
__decorate([
    editable()
], KnowAWordStore.prototype, "wordTask", void 0);
__decorate([
    memoize
], KnowAWordStore.prototype, "knowAWordLegacy", null);
__decorate([
    computed
], KnowAWordStore.prototype, "form", null);
__decorate([
    computed
], KnowAWordStore.prototype, "word", null);
__decorate([
    computed
], KnowAWordStore.prototype, "prefix", null);
__decorate([
    computed
], KnowAWordStore.prototype, "postfix", null);
__decorate([
    computed
], KnowAWordStore.prototype, "accuracy", null);
__decorate([
    computed
], KnowAWordStore.prototype, "contains", null);
__decorate([
    computed
], KnowAWordStore.prototype, "solution", null);
__decorate([
    computed
], KnowAWordStore.prototype, "manualSend", null);
__decorate([
    computed
], KnowAWordStore.prototype, "casesensitive", null);
__decorate([
    computed
], KnowAWordStore.prototype, "showAlternatives", null);
__decorate([
    computed
], KnowAWordStore.prototype, "regex", null);
__decorate([
    computed
], KnowAWordStore.prototype, "legacyImages", null);
__decorate([
    computed
], KnowAWordStore.prototype, "legacyComments", null);
__decorate([
    memoize
], KnowAWordStore, "serializeInfo", null);
